// extracted by mini-css-extract-plugin
export default {"opened":"x9AUPxYkQO4TAEObzqBB","closed":"xkhyzs8U1uXIer8v9tuH"};